<app-modal-header title="Change password" />

<form [formGroup]="form" (ngSubmit)="submit()" class="modal-form" novalidate>
  <app-modal-body>
    @if (serverError()) {
      <p class="form-error" role="alert">{{ serverError() }}</p>
    }

    <div class="form-field">
      <label class="form-field__label" for="cp-current">Current password</label>
      <input id="cp-current" type="password" class="field-input field-input--text" formControlName="currentPassword"
             autocomplete="current-password" placeholder="Enter current password" data-modal-autofocus />
      @if (showError(form.controls.currentPassword)) {
        <p class="form-field__error">Enter your current password.</p>
      }
    </div>

    <div class="form-field">
      <label class="form-field__label" for="cp-new">New password</label>
      <input id="cp-new" type="password" class="field-input field-input--text" formControlName="password"
             autocomplete="new-password" [placeholder]="'At least ' + minLength + ' characters'" />
      @if (showError(form.controls.password)) {
        <p class="form-field__error">
          {{ form.controls.password.hasError('required') ? 'Enter a new password.' : 'Use at least ' + minLength + ' characters.' }}
        </p>
      }
    </div>

    <div class="form-field">
      <label class="form-field__label" for="cp-confirm">Confirm new password</label>
      <input id="cp-confirm" type="password" class="field-input field-input--text" formControlName="passwordConfirmation"
             autocomplete="new-password" placeholder="Repeat new password"
             [class.field-input--invalid]="form.hasError('passwordMismatch') && form.controls.passwordConfirmation.touched" />
      @if (showError(form.controls.passwordConfirmation)) {
        <p class="form-field__error">Repeat the new password.</p>
      } @else if (form.hasError('passwordMismatch') && form.controls.passwordConfirmation.touched) {
        <p class="form-field__error">The passwords don't match.</p>
      }
    </div>
  </app-modal-body>

  <app-modal-footer>
    <button type="button" class="btn--secondary" [disabled]="saving()" (click)="modalRef.dismiss()">Cancel</button>
    <button type="submit" class="btn--primary" [disabled]="saving()">
      {{ saving() ? 'Updating…' : 'Update password' }}
    </button>
  </app-modal-footer>
</form>
